import $ from 'jquery';
import app from 'app';
import Drawer from '@component/drawer';
import { SpeedBumpOverlay } from '@feature/citi-redirects/src/citi-redirects';
import TagManager from '../../utils/TaggingUtil';

export default class AccountNotificationsDrawer extends Drawer {
  constructor(options) {
    super(options);
    $('.acc-notif-add-payment').on('click', this.displayCreditOverlay.bind(this));
    $('.acc-notif-set-default-card').on('click', this.defaultCardTags);
    $('.goto-star-rewards').on('click', this.rewardCardTags);
    $('.icon-ui-chevron-left-gr-huge').on('click', this.focusIndicator);
    $('.citi-redirect').on('click', this.addToFusionTags);
    $('.acc-notif-enroll').on('click', this.enrollRewardsTags);
    SpeedBumpOverlay.init();
  }

  showDrawer() {
    super.showDrawer();
    // prevent background from scrolling
    const body = $('body');
    body.css('top', '0');
    body.css('left', '0');
    body.css('right', '0');
    body.css('bottom', '0');
    body.css('position', 'fixed');
    TagManager.createLinkClickTag('my_notifications');
  }

  hideDrawer() {
    super.hideDrawer();
    // allow scrolling again
    const body = $('body');
    body.css('top', '');
    body.css('left', '');
    body.css('right', '');
    body.css('bottom', '');
    body.css('position', '');
    TagManager.createLinkClickTag('x');
  }

  displayCreditOverlay() {
    TagManager.createLinkClickTag('add_card_to_wallet');
    this.hideDrawer();
    setTimeout(() => {
      app.channel.trigger('notification:addpayment');
    }, 750);
  }

  enrollRewardsTags() {
    TagManager.createLinkClickTag('enroll_in_loyalty');
  }

  rewardCardTags() {
    TagManager.createLinkClickTag('view_reward_card_details');
  }

  defaultCardTags() {
    TagManager.createLinkClickTag('set_prop_card_default');
  }

  addToFusionTags() {
    TagManager.createLinkClickTag('add_prop_card_to_fusion');
  }

  focusIndicator() {
    app.channel.trigger('focus:indicator:elem');
  }
}
